// 搭讪吃瓜站点数据 —— 仅供本站展示使用

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "今日热瓜", href: "#hot" },
  { label: "开场白话术", href: "#opening" },
  { label: "金句墙", href: "#lines" },
  { label: "实战拆解", href: "#case" },
  { label: "避坑雷区", href: "#pitfalls" },
  { label: "吃瓜问答", href: "#faq" },
];

export interface SceneTab {
  id: string;
  label: string;
}

export const sceneTabs: SceneTab[] = [
  { id: "all", label: "全部场景" },
  { id: "first", label: "初次见面" },
  { id: "cafe", label: "咖啡店&酒馆" },
  { id: "gym", label: "健身房" },
  { id: "commute", label: "通勤路上" },
  { id: "party", label: "聚会社交" },
  { id: "online", label: "线上开场" },
];

export interface PhraseCard {
  scene: string;
  tag: string;
  title: string;
  line: string;
  note: string;
  score: string;
}

export const phraseList: PhraseCard[] = [
  { scene: "first", tag: "顺理成章", title: "用求助降低防御", line: "不好意思打扰一下，我在找一家叫「小满」的咖啡店，导航给我指晕了——你平时会来这附近喝吗？", note: "先给一个可执行的小忙，对方顺手帮完，再自然把话题引到「你」身上，防备心瞬间降一半。", score: "高分开场" },
  { scene: "cafe", tag: "就地取材", title: "借手里单品聊起来", line: "看你点的这杯特调挺特别，我一直纠结菜单——你手上这杯好喝吗？推荐一下。", note: "用眼前的实物开场最不尴尬，既给了对方评价权，又给了你追问下去的接口。", score: "最自然" },
  { scene: "gym", tag: "同好切入", title: "组间休息的正确打开", line: "你的动作轨迹挺稳的，我练引体总晃。刚看你那组，方便的话能指点一下动作要领吗？", note: "健身房最怕油腻，把「我想认识你」翻译成「我想请教你」，目标感错位，氛围就不紧张。", score: "克制加分" },
  { scene: "commute", tag: "借景发挥", title: "把路况变成话题", line: "这站每次到早高峰人都多，你是不是也专门错峰出门？", note: "用一个你们都正在经历的现场感话题开场，不查户口，不硬夸，先确认彼此在同一个频道。", score: "高频可用" },
  { scene: "party", tag: "轻量社交", title: "从人群里捞个接口", line: "刚听你聊旅行聊得挺带劲，正好我下个月想去云南，你这边的路线攻略能分享一份吗？", note: "在聚会里，话题是流动的，抓住对方正在输出观点的瞬间切入，比硬凑近乎自然得多。", score: "氛围担当" },
  { scene: "online", tag: "反套路钩子", title: "用一个问题代替你好", line: "刚刷到你主页那只猫，我家猫也有同款炸毛——它是不是每次见你回家都这样？", note: "线上开场切忌「在吗、你好、交个朋友」，用对方主页的真实细节当钩子，才有来有回。", score: "破冰利器" },
  { scene: "first", tag: "坦诚示弱", title: "把紧张说出口", line: "说实话我刚才想了好几句开场白，到你面前全忘了——要不我们从你的名字开始认识？", note: "把「紧张」讲出来不是减分，是真诚的加分项。对方看到的是一个敢表达的真实的人。", score: "真诚杀" },
  { scene: "cafe", tag: "环境共感", title: "分享当下的松弛感", line: "这家店放的音乐挺对我胃口，你常来吗？还是也被门口的排队人气拉进来的？", note: "把注意力放到共享的当下，而不是盯着对方审阅，双方都会更松弛，也更愿意聊下去。", score: "氛围加分" },
  { scene: "gym", tag: "适度留白", title: "别把话题说死", line: "你练得挺有章法的，估计是稳定打卡的老手了吧？我也在坚持，就是偶尔犯懒。", note: "给自己留个「偶尔犯懒」的台阶，给对方留个「我也这样」的接话空间，对话才不冷场。", score: "进退有度" },
  { scene: "online", tag: "二选一提问", title: "用选择题降低压力", line: "猜猜我第一眼被你的哪张照片吸引——是那张登山照，还是那只猫？答对有彩蛋。", note: "封闭式提问把压力降到最低，无论对方选哪个，你都有话可以自然接下去。", score: "高回复率" },
  { scene: "commute", tag: "观察入微", title: "从细节里找尊重", line: "你刚给老人让座还特意扶了一下，现在很少有人这么细心了——正好坐这边，聊两句不介意吧？", note: "夸具体的善举而非外貌，既显观察力，也透露出你珍视的品质，层次一下就上来了。", score: "印象分拉满" },
  { scene: "party", tag: "留个尾巴", title: "结束前埋下后续", line: "这话题聊起来真停不下来，不过我得先去跟朋友打个招呼——你微信叫什么？回头把那份攻略发你。", note: "好的开场不止于当下，敢于主动结束、并自然留下一个「有理由继续」的接口，才叫完整。", score: "高手收尾" },
];

export interface GoldenLine {
  text: string;
  type: string;
  likes: string;
}

export const goldenLines: GoldenLine[] = [
  { text: "我不是在搭讪，只是怕错过一个有趣的人，那代价太大了。", type: "真诚流", likes: "2.4k" },
  { text: "你笑起来像这杯咖啡里的第一口热气，让人忍不住想靠近。", type: "文艺流", likes: "1.8k" },
  { text: "借你三分钟聊聊天，聊得好就当我请客，聊不好就当你在做慈善。", type: "幽默流", likes: "3.1k" },
  { text: "别紧张，我又不吃人——不过你要是愿意，倒是可以吃个饭。", type: "俏皮流", likes: "2.9k" },
  { text: "我可能不是最会说话的人，但我一定是最想认真听你说话的人。", type: "踏实流", likes: "1.6k" },
  { text: "第一次见面就聊这么投缘，要不给未来的朋友一个认识的机会？", type: "分寸流", likes: "2.2k" },
  { text: "你今天这条裙子真好看，不过我更好奇穿它的人会聊些什么。", type: "观察流", likes: "1.9k" },
  { text: "如果你也刚好觉得「认识一下」挺不错，那我们就别让它溜走。", type: "大方流", likes: "2.7k" },
];

export interface HotCard {
  title: string;
  category: string;
  digest: string;
  heat: string;
  image: string;
  reads: string;
}

export const hotCards: HotCard[] = [
  {
    title: "咖啡馆「借杯问路」三段式开场，成功率凭啥这么高？",
    category: "套路深扒",
    digest: "拆解一段被 5000+ 人转发的现场实录：求助→请教→留接口，为什么这套节奏能让对方主动续聊。",
    heat: "热",
    reads: "12.8w",
    image: "https://readdy.ai/api/search-image?query=warm%20cozy%20coffee%20shop%20scene%20two%20people%20sitting%20at%20a%20small%20round%20table%20having%20a%20lively%20conversation%20over%20lattes%2C%20soft%20afternoon%20window%20light%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20magazine%20photography%2C%20cozy%20casual%20atmosphere&width=900&height=640&seq=hot-cafe-01&orientation=landscape",
  },
  {
    title: "健身房里那句「能指点一下吗」，为什么比「加个微信」高明？",
    category: "高手过招",
    digest: "同样是搭讪，一个被当成搭子，一个被拉黑。差别就在你给对方留的「台阶」够不够。",
    heat: "新",
    reads: "8.4w",
    image: "https://readdy.ai/api/search-image?query=modern%20bright%20fitness%20gym%20interior%20with%20weights%20and%20machines%2C%20two%20people%20talking%20in%20the%20background%20between%20sets%2C%20warm%20natural%20lighting%2C%20cream%20and%20muted%20coral%20tones%2C%20editorial%20documentary%20style%20photography&width=900&height=640&seq=hot-gym-02&orientation=landscape",
  },
  {
    title: "「二选一提问法」刷屏：一封选择题，为什么回复率翻倍？",
    category: "金句技巧",
    digest: "开放式问题容易把天聊死，封闭式选择却能逼出回应。心理学原理 + 五个可直接改的句子。",
    heat: "爆",
    reads: "19.6w",
    image: "https://readdy.ai/api/search-image?query=overhead%20view%20of%20two%20coffee%20cups%20and%20a%20phone%20with%20chat%20bubbles%20on%20screen%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20cozy%20cafe%20table%2C%20soft%20natural%20light%2C%20editorial%20flat%20lay%20photography&width=900&height=640&seq=hot-choice-03&orientation=landscape",
  },
  {
    title: "通勤地铁上的 3 秒开场：把「查户口」变成「看现场」",
    category: "避坑指南",
    digest: "早晚高峰的高频场景，哪些开场是雷区，哪些能聊出火花？一条通勤实录给出答案。",
    heat: "火",
    reads: "6.9w",
    image: "https://readdy.ai/api/search-image?query=bright%20modern%20subway%20carriage%20interior%20with%20seats%20and%20handrails%2C%20soft%20morning%20light%20streaming%20through%20windows%2C%20warm%20cream%20and%20orange%20tones%2C%20clean%20minimal%20editorial%20photography&width=900&height=640&seq=hot-train-04&orientation=landscape",
  },
];

export interface CaseStep {
  label: string;
  title: string;
  before: string;
  after: string;
}

export const caseSteps: CaseStep[] = [
  {
    label: "第一步",
    title: "搭话靠「忙」，不靠「夸」",
    before: "「美女，你一个人吗？加个微信呗。」",
    after: "「请问这附近有推荐的咖啡店吗？我刚搬来，看你像是常客。」",
  },
  {
    label: "第二步",
    title: "话题靠「追问」，不靠「查户口」",
    before: "「你多大了？做什么工作？住哪？」",
    after: "「你常来这家，那一定喝得出哪款最招牌吧？教教我。」",
  },
  {
    label: "第三步",
    title: "结束靠「留口」，不靠「硬撑」",
    before: "「再聊会儿嘛，别急着走。」",
    after: "「今天聊得很开心，不过我朋友在等我。微信留一个，改天请你喝这家新豆子？」",
  },
];

export interface Pitfall {
  icon: string;
  title: string;
  desc: string;
  tone: string;
}

export const pitfalls: Pitfall[] = [
  { icon: "ri-user-heart-line", title: "死缠烂打式追问", desc: "对方礼貌回应了两次不代表想继续。看到冷淡信号还连环发问，基本属于当场社死。", tone: "劝退" },
  { icon: "ri-voiceprint-line", title: "油腻开场白轰炸", desc: "「美女有对象吗」「缘分让我们相遇」这类油到发亮的句子，开口即送走。", tone: "劝退" },
  { icon: "ri-eye-line", title: "外貌轰炸式硬夸", desc: "刚认识就盯着外表反复输出夸奖，会让对方觉得你只看见皮囊，而不是人。", tone: "减分" },
  { icon: "ri-forbid-line", title: "查户口式连环问", desc: "工资、年龄、家庭住址一套连招，把聊天变成审讯，谁都会想逃。", tone: "减分" },
  { icon: "ri-walk-line", title: "忽略现场信号", desc: "对方戴着耳机、正打电话、在赶路，这种时刻硬凑上去，等于还没开始就输了。", tone: "劝退" },
  { icon: "ri-group-line", title: "当众让人下不来台", desc: "在朋友堆里被当众搭话还开带颜色的玩笑，无论多会聊都救不回来。", tone: "致命" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: "搭讪开场白真的有用吗？还是看脸？", a: "看脸是幸存者偏差的错觉。搭讪的核心不是「你说得够不够漂亮」，而是「你有没有让对方舒服地接话」。真诚的语气、得体的距离、对现场细节的观察，比任何金句都重要。脸是入场券，话术是下半场。这里整理的所有案例，都在讲同一件事：让对方觉得「跟你聊天是安全的、轻松的」。" },
  { q: "第一句话该从哪个场景切入最不容易尬？", a: "没有绝对安全的场景，但有更不容易尬的切口：永远从「双方正在共享的现场」出发。咖啡馆聊菜单、健身房请教动作、通勤聊路况、聚会聊别人的话题。别急着把目标对准对方查户口，先让彼此处在同一个频道里，话题自然会流向你想去的地方。" },
  { q: "被对方拒绝了，该怎么体面收场？", a: "拒绝不等于否定你这个人，可能只是时机、场合不对。最体面的收场是：快速、大方地退一步，比如「好，那打扰了，祝你玩得开心」，然后干净利落地走开。你越是能坦然接受结果，对方反而越会对你留一个好印象——这种分寸感，本身就是一种高情商。" },
  { q: "线上社交的开场白，有什么跟线下不一样？", a: "线下靠氛围和临场，线上靠「细节」和「留白」。线上一上来就发「你好、在吗」几乎必死，因为对方没有任何理由继续。更好的做法是抓住对方主页里一个真实的细节（宠物、爱好、一张照片）发起一个具体提问，给对方一个低成本就能接住的话题。" },
  { q: "怎么判断对方对我是真有兴趣还是纯礼貌？", a: "关键看两个信号：是否主动延长对话，以及是否愿意推进关系。如果只是「嗯、哦、是」，那是礼貌；如果会追问你、接你的梗、主动分享自己的事、愿意约下一次见面，那才叫有兴趣。学会读懂信号，能帮你省下大量自我感动式的努力。" },
  { q: "有没有一句话就能让对方心动的万能公式？", a: "没有万能公式，但有一个可以反复套用的结构：真实 + 细节 + 尊重 + 一点留白。用一句真诚的观察打开局面，尊重对方的边界，同时别把话说死，给对方留出接话和拒绝的空间。真诚永远是性价比最高的「套路」。" },
];

export interface StatItem {
  num: string;
  label: string;
}

export const stats: StatItem[] = [
  { num: "300+", label: "话术案例" },
  { num: "46w", label: "每周阅读" },
  { num: "1200+", label: "实战拆解" },
  { num: "92%", label: "读者好评" },
];